import getLanguageId from '../i18n/getLanguageId';

const getFixedOptionsByPackage = (pack, extrasData, locale) => {
  const options = [];
  const localeId = getLanguageId(locale);

  if (pack?.extras?.length && localeId) {
    pack.extras.forEach((extra) => {
      if (extra.fixedQuantity > 0) {
        const fullExtra = extrasData?.find((ex) => ex.id === extra.id);
        if (fullExtra && !fullExtra.showIfWithAccommodations) {
          options.push(fullExtra.product?.name[localeId]);
        }
      }
    });
  }
  return options;
};

export default getFixedOptionsByPackage;
